<template>
    <div>
        <Top />
        <div class="content detailBox mb20">
            <slot></slot>
        </div>
        <Bottom />
    </div>
</template>

<style lang="scss" scoped>
    .detailBox{background:#fff;padding:15px;min-height:65vh;margin-top:-100px;position:relative;z-index:10;}
</style>

<script>
import Top from "@/views/index/Top.vue";
import Bottom from "@/views/index/Bottom.vue";
export default {
    name: "detail",
    components: {
        Top,
        Bottom,
    },
    data(){
        return {
        }
    },
    methods:{
    },
};
</script>
